<template>
<div class="chapter">
<div class="inner_page">
<p class="indent">Up until April 1916 there was no issue of steel helmets and the troops fought wearing their issue cloth caps which provided little in the way of protection against small arms ammunition, spherical lead shrapnel bullets or shell fragments. The first of the Brodie Helmets or Helmet, Steel Mark 1, began to appear on the Western Front in late 1915 but they did not become general issue until early 1916. Known variously as ‘tin hats’, ‘battle bowlers’ and even ‘soup bowls’, the basic design went through a number of alterations and improvements and by the end of the war some 7.5 million Brodies had been manufactured.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 31_fm0314.vue?643ec933